module.exports = __webpack_public_path__ + "img/mobile-hero-art.ebc904f6.png";